<app-page>
  <h1 style="color: red">Page Not Found</h1>
</app-page>
